export default {
  ticket: null,
  tickets: null,
  newTickets: null,
  showTicketDetailDrawer: false,
  showTicketDetailDrawerSection: "",
  ticketId: null,
  ticketsDownloads: null,
  defaultObjections: [
    "precio",
    "más adelante",
    "sin stock",
    "ya compro",
    "crédito",
    "busca otras características",
    "curioso",
    "post venta",
    "dejó de contestar",
    "spam",
    "lo manejará el dealer",
    "no desea",
    "fuera de cobertura",
    "vecino",
    "repetido",
  ],
  defaultPrioritiesColors: [
    "#FF6361",
    "#FF921E",
    "#FFCC00",
    "#EDE500",
    "#C2DB08",
    "#78DD04",
    "#02E09D",
    "#029AE0",
    "#BD07F4",
    "#6107F2",
  ],
  unsubscribeAllNewTickets: null,
  unsubscribeGetTicket: null,
  ticketsByState: {},
};
